/**
 * Microphone Icon Component
 *
 * Microphone icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/microphone-icon
 */
import { createIconNode } from '../create-icon';
const MICROPHONE_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [{ d: 'M8.00003 11.5V14.5M8.00003 11.5C9.03437 11.5 10.0263 11.0891 10.7577 10.3577C11.3862 9.72918 11.9023 8.8749 12.0001 7.99999M8.00003 11.5C6.96568 11.5 5.97369 11.0891 5.24229 10.3577C4.61378 9.72918 4.09791 8.8749 4.00012 7.99999M8.0037 1.5C9.20032 1.5 10.1704 2.47005 10.1704 3.66667L10.1705 7.27246C10.1705 8.46908 9.2005 9.43913 8.00388 9.43913C6.80726 9.43913 5.83721 8.46908 5.83721 7.27246L5.83703 3.66667C5.83703 2.47005 6.80708 1.5 8.0037 1.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [{ d: 'M12 16.5V19.5M12 16.5C13.1935 16.5 14.3381 16.0259 15.182 15.182C15.9072 14.4568 16.3593 13.5095 16.4721 12.5M12 16.5C10.8065 16.5 9.66192 16.0259 8.818 15.182C8.09279 14.4568 7.64067 13.5095 7.52783 12.5M12 4.5C13.3807 4.5 14.5 5.61929 14.5 7V12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.49998 13.3807 9.49998 12V7C9.49998 5.61929 10.6193 4.5 12 4.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
});
export function MicrophoneIcon(props) {
    return createIconNode(MICROPHONE_ICON, props);
}
//# sourceMappingURL=microphone.js.map